// MyInvoices Page
export default function MyInvoices() { return <div><h1 className="text-3xl font-bold">My Invoices</h1><p className="mt-4">View and download your invoices.</p></div>; }